(function () {
    'ngInject';

    angular.module('app.shared.services').service('ImageFilterManagerService', imageFilterManagerService);

    function imageFilterManagerService(
        $rootScope,
        MdDialogService,
        UsersAPIService,
        RemoveBgAPIService,
        CutoutProAPIService
    ) {
        function getFilterParameters($scope, imageFilterToUse) {
            let parameters = {};
            switch (imageFilterToUse) {
                case 'removeBg': {
                    parameters = {
                        apiKeyProperty: ['RemoveBgAPIKey', $scope.apiKeys[imageFilterToUse]],
                        showApiKeyInput: ['removeBg', false],
                        setApiKeyMethod: 'setRemoveBgAPIKey',
                        imageFilterMethod: ['removeBg', null],
                        apiKeyValidationMethod: 'isValidAPIKey'
                    };
                    break;
                }
                case 'cutoutPro': {
                    parameters = {
                        apiKeyProperty: ['CutoutProAPIKey', $scope.apiKeys[imageFilterToUse]],
                        showApiKeyInput: ['cutoutPro', false],
                        setApiKeyMethod: 'setCutoutProAPIKey',
                        imageFilterMethod: ['faceCutout', true],
                        apiKeyValidationMethod: 'isValidAPIKey'
                    };
                    break;
                }
            }

            return parameters;
        }

        async function filterManager($scope, imageFilterToUse) {
            const parameters = getFilterParameters($scope, imageFilterToUse);
            const filterNameCapitalized = imageFilterToUse.charAt(0).toUpperCase() + imageFilterToUse.slice(1);
            const cutoutPro = 'cutoutPro',
                removeBg = 'removeBg';

            if (parameters.apiKeyValidationMethod) {
                let response;
                if (imageFilterToUse === cutoutPro)
                    response = await CutoutProAPIService[parameters.apiKeyValidationMethod](
                        parameters.apiKeyProperty[1]
                    );
                else if (imageFilterToUse === removeBg)
                    response = await RemoveBgAPIService[parameters.apiKeyValidationMethod](
                        parameters.apiKeyProperty[1]
                    );

                if (
                    response &&
                    (imageFilterToUse === cutoutPro || (!response.status && imageFilterToUse === removeBg))
                ) {
                    UsersAPIService[parameters.setApiKeyMethod](parameters.apiKeyProperty[1]);
                    $rootScope.user[parameters.apiKeyProperty[0]] = $scope.apiKeys[parameters.apiKeyProperty[1]];
                    $scope.showApiKeyInput[parameters.showApiKeyInput[0]] = parameters.showApiKeyInput[1];

                    const { imageSelected, bulkEdit, selectedObjectGroup } = $scope;

                    if (bulkEdit?.enabled) {
                        const objects = selectedObjectGroup?._objects;
                        for (const object of objects) {
                            if (object.imageFile) {
                                await $scope[parameters.imageFilterMethod[0]](parameters.imageFilterMethod[1]);
                            }
                        }
                    } else {
                        if (imageSelected.imageFile) {
                            await $scope[parameters.imageFilterMethod[0]](parameters.imageFilterMethod[1]);
                        }
                    }

                    MdDialogService.showSuccessModal(
                        `Successful integration with ${filterNameCapitalized}!`,
                        "Let's apply filters!"
                    );
                } else if (
                    (!response && imageFilterToUse === cutoutPro) ||
                    (response && response.status && imageFilterToUse === removeBg)
                ) {
                    $scope.apiKeys[imageFilterToUse] = null;
                    MdDialogService.showSuccessModal(
                        `There was an error connecting with ${filterNameCapitalized}!😅`,
                        'Check your API Key and try again'
                    );
                }
            }
        }
        return {
            filterManager: filterManager
        };
    }
})();
